import React from 'react';
import { BankOutlined } from '@ant-design/icons';
const AdminIcon = (props: any) => {
  return <BankOutlined style={{ fontSize: '19px' }} />;
};

export default AdminIcon;
